/** 是否在 UI 展示剧集播放量/观看数（false = 隐藏，逻辑保留） */
export const SHOW_VIEW_COUNT = false

/** 是否启用奖励任务系统（false = 隐藏入口并停用任务查询/执行/领取） */
export const ENABLE_REWARD_TASKS = true
